
/*
window.addEventListener("klaviyoForms", function(e) { 

  if (e.detail.type == 'submit') {
  	fbq('track', 'CompleteRegistration');
  }
});
*/

window.addEventListener('DOMContentLoaded',() => {

  const banners = document.querySelectorAll('.banner');
  banners.forEach( b => {

    const h = b.querySelector('.banner__heading');
    if (h && h.innerText.length > 0) b.classList.add('has-text');
  });

});
/**
  collection list/thumbnail view
  */
window.addEventListener('DOMContentLoaded',() => {

  if (localStorage === undefined) return;
  
  const collections = document.querySelectorAll('.collection');
  const curView = localStorage.collectionView !== undefined ? localStorage.collectionView : 'grid';
  
  collections.forEach( col => {

    const section = col.closest('div.shopify-section');

    if (section)
    {
      const fc = section.querySelector('#FacetSortForm');

      if (fc)
      {
        const tb = document.createElement('div');
        tb.classList.add('lm-collection-view-toolbar');

        const thumbBtn = document.createElement('button');
        thumbBtn.classList.add('fas','fa-border-all');

        thumbBtn.addEventListener('click',(evt) => {
          evt.preventDefault();
          section.classList.remove('lm-collection-list-view');
          localStorage.collectionView = 'grid';
        });

        tb.appendChild(thumbBtn);

        const listBtn = document.createElement('button');
        listBtn.classList.add('far','fa-list-alt');

        listBtn.addEventListener('click',(evt) => {
          evt.preventDefault();
          section.classList.add('lm-collection-list-view');
          localStorage.collectionView = 'list';
        });

        tb.appendChild(listBtn);        

        fc.appendChild(tb);

        if (curView == 'list') section.classList.add('lm-collection-list-view');
      }
    }
    
  });
  
});

const moneyFormat = '$ {{amount}} USD';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

window.addEventListener('DOMContentLoaded',() => {

  if (document.querySelector('.gryffeditor'))
  {
    const oq = document.querySelector('main > .grid > .grid__item.large--one-quarter');
    const tq = document.querySelector('main > .grid > .grid__item.large--three-quarters');

    if (oq && tq)
    {
      const main = document.querySelector('main');
      const topGrid = document.querySelector('main > .grid');
      const article = tq.querySelector('article');

      main.prepend(article);
      main.removeChild(topGrid);

      main.classList.add('legacy_gempage');
      article.classList.remove('grid__item');      
    }
  }

});

/** used by custom properties for products **/

function lmNumberCheckMinMax(el){
  if(el.value != ""){
    if(parseInt(el.value) < parseInt(el.min)){
      alert('You must enter a value of at least "' + el.min + '"');
      el.value = el.min;
    }
    if(parseInt(el.value) > parseInt(el.max)){
      alert('You can only enter a max value of "' + el.max + '"');
      el.value = el.max;
    }
  }
}

function lmShowProductOptions(el) {

  const isVisible = el.value != 'None';
  
  const options = el.parentNode.parentNode.querySelectorAll('.lm-product-option');
  options.forEach( (opt,idx) => {
    if (isVisible == true) opt.classList.add('is-visible');
    else opt.classList.remove('is-visible');
  });

  //update our hidden customization indicator
  const hf = el.parentNode.parentNode.querySelector('[name="properties[_is_customized]"]');
  if (hf) hf.value = el.value;

}

function lmToggleProductOptions(el) {

  const isVisible = el.value != 'No';
  const optionContainer = el.parentNode.parentNode.querySelector('.lm-product-option-container');;

  if (isVisible == true) optionContainer.classList.add('is-visible');
  else optionContainer.classList.remove('is-visible');

  //update our hidden customization indicator
  const hf = el.parentNode.parentNode.querySelector('[name="properties[_is_customized]"]');
  if (hf) hf.value = el.value;

}

function lmShowOptionsFromCount(el) {

  const itemCount = parseInt(el.value);

  const options = el.parentNode.parentNode.querySelectorAll('.lm-product-option');
  options.forEach( (opt,idx) => {

    if (idx < itemCount)
    {
      opt.classList.add('is-visible');
    }
    else
    {
      opt.classList.remove('is-visible');
      opt.querySelector('input').value = '';
    }
  });
}

function lmFocusInput(el)
{
  //console.log('Focus',el);
  el.select();
}

window.addEventListener('DOMContentLoaded',() => {

  const prodOpts = document.querySelectorAll('.lm-product-options');
  prodOpts.forEach( prodOpt => {

    const hf = document.createElement('input');
    hf.setAttribute('type','hidden');
    hf.setAttribute('name','properties[_is_customized]');
    hf.setAttribute('value','no');

    const formId = 'product-form-' + prodOpt.closest('product-info').dataset.section;
    hf.setAttribute('form',formId);
    
    prodOpt.prepend(hf);

  });
  
});

/**
  * passes wisepops events to elevar
  */
class LMWisePops {

    constructor()
    {
      this.addListener();
    }

    addListener()
    {
      wisepops('listen', 'after-form-submit', (event) => {
        this.handleEvent(event.type,event.target);   
      });
    };
      
    handleEvent(eventType,targets)
    {
      Object.values(targets).some( tgt => {

        if (tgt?.classList && tgt.classList.contains('wisepops-field-email'))
        {
          this.handleEmail(tgt);
          return;
        }
        else if (tgt?.data != undefined)
        {
          this.handlePhone(tgt);
        }    
      })
    };

    handleEmail(inputForm)
    {
      const data = {
        event: 'dl_subscribe',
        lead_type: 'email',
        user_properties: {
          customer_email: inputForm.value
        }
      };

      //console.log('Push To Elevar',data);

      window.ElevarDataLayer.push(data);
    };

    handlePhone(inputForm)
    {
      const phoneData = JSON.parse(inputForm.data);
      const phoneNum = phoneData.dialCode + phoneData.value.replace(/ /g,'');
      
      const data = {
        event: 'dl_subscribe',
        lead_type: 'phone',
        user_properties: {
          customer_phone: phoneNum
        }
      };

      //console.log('Push To Elevar',data);

      window.ElevarDataLayer.push(data);

    };
    
};
  

/**
  * wisepops to elevar event tracking
  */
window.addEventListener('DOMContentLoaded',() => {

  const wisePopListener = setInterval( () => {
    
    if (typeof(wisepops) != 'undefined')
    {
      clearInterval(wisePopListener);
      new LMWisePops();
    }
    
  }, 1000);

});


/*
Load slider on the home page collection list
window.addEventListener('load',() => {

    new Flickity( '.collection-list', {
  		contain: true,
  		wrapAround: false,
  		groupCells:true,
        imagesLoaded: true,
	});	  

});
*/
